<template>
  <div v-if="fullscreen" :class="{ 'fullscreen-container': open }">
    <div :class="{ 'fullscreen-header': open }">
      <FriedIconButton v-if="open" data-external="search-back-button" @click="hide">
        <FriedIcon icon="arrow-left" />
      </FriedIconButton>
      <div class="search-input-container" @focus="show" @click="show" @keyup.esc="hide">
        <slot name="input" />
      </div>
    </div>
    <div v-if="open" class="fullscreen-content">
      <slot name="content" />
    </div>
    <div v-if="open">
      <slot name="footer" />
    </div>
  </div>

  <div v-else v-click-outside="hide">
    <FriedFloater
      :placement="placement"
      :main-axis-offset="offset[0]"
      :cross-axis-offset="offset[1]"
      :show="open"
      :same-width-as-ref="true"
      strategy="fixed"
    >
      <template #reference>
        <div @focus="show" @click="show" @keyup.esc="hide">
          <slot name="input" />
        </div>
      </template>
      <div :class="['dropdown-container', { thin: thinPadding }]">
        <slot name="content" />
        <slot name="footer" />
      </div>
    </FriedFloater>
  </div>
</template>

<script lang="ts">
import { Placement } from '@getaccept/fried-tofu';
import { defineComponent } from 'vue';
import type { PropType } from 'vue';

export default defineComponent({
  name: 'SearchLayout',
  props: {
    placement: {
      type: String as PropType<Placement>,
      default: Placement.BottomStart,
    },
    offset: {
      type: Array as PropType<number[]>,
      default: () => [0, 0],
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    open: {
      type: Boolean,
      required: true,
    },
    thinPadding: {
      type: Boolean,
    },
  },
  emits: ['open', 'close'],
  setup(_, { emit }) {
    const show = () => {
      emit('open');
    };

    const hide = () => {
      emit('close');
    };

    return {
      show,
      hide,
    };
  },
});
</script>
<style lang="scss" scoped>
.fullscreen-container {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-200);
  position: absolute;
  top: var(--topbar-padding);
  left: 0;
  width: 100%;
  height: calc(100% - var(--topbar-padding));
  background: var(--white);
  padding: var(--spacing-100);
  z-index: $z-base;

  .fullscreen-header {
    display: flex;
    gap: var(--spacing-100);
    padding-top: var(--spacing-100);

    .search-input-container {
      flex-grow: 1;
    }
  }

  .fullscreen-content {
    overflow: auto;
    height: 100%;
  }
}

.dropdown-container {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-100);
  padding: var(--spacing-100);
  border-radius: var(--radius-small);
  box-shadow: var(--shadow-3);
  min-width: 13rem;
  background: var(--white);
  z-index: 2147483003;
  position: relative;

  &.thin {
    padding: var(--spacing-50);
  }
}
</style>
